import type { MuhuratResponse } from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type { MuhuratResponse };
export type { MuhuratTimePeriod, MuhuratPanchangInfo, MuhuratVara, MuhuratTimeSlot } from "@ishvaram/api-client";

export async function getMuhurat(
  date?: string,
  place?: string,
  latitude?: number,
  longitude?: number,
  timezone?: string,
): Promise<MuhuratResponse> {
  const params = new URLSearchParams();
  if (date) params.set("date", date);
  if (place) params.set("place", place);
  if (latitude !== undefined) params.set("latitude", String(latitude));
  if (longitude !== undefined) params.set("longitude", String(longitude));
  if (timezone) params.set("timezone", timezone);
  const qs = params.toString();
  return apiRequest<MuhuratResponse>(`/muhurat${qs ? `?${qs}` : ""}`);
}
